module.exports = __webpack_public_path__ + "img/senora_parallax.12f5f143.jpg";